import { render, staticRenderFns } from "./delivered-service-point.component.vue?vue&type=template&id=58e44271"
import script from "./delivered-service-point.component.ts?vue&type=script&lang=ts&external"
export * from "./delivered-service-point.component.ts?vue&type=script&lang=ts&external"
import style0 from "./delivered-service-point.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports